/* eslint-disable camelcase */
import { GET_WORKSHOP_TYPES } from '../constants/workshopTypes';

// eslint-disable-next-line import/prefer-default-export
export const getWorkshopTypes = (workshopId, data) => {
  const types = data.reduce((obj, type) => {
    /* eslint-disable no-param-reassign */
    obj[type.name] = true;
    return obj;
  }, {});
  return (dispatch) => {
    dispatch({
      type: GET_WORKSHOP_TYPES,
      workshopId,
      types,
    });
  };
};
